export type MaterialMovementType = "received" | "transferred" | "used" | "inventoried";

export interface MaterialMovement {
  id: string;
  type: MaterialMovementType;
  amount: number;
  at: string;
  location?: string;
}

const CODE_ALPHABET = "23456789ABCDEFGHJKMNPQRSTUVWXYZ";

export function createMarkerCode(random = Math.random): string {
  const pick = () => CODE_ALPHABET[Math.floor(random() * CODE_ALPHABET.length)];
  return `${pick()}${pick()}-${pick()}${pick()}${pick()}`;
}

export function calculateMaterialBalance(movements: MaterialMovement[]) {
  let calculated = 0;
  let inventoried: number | null = null;

  for (const movement of movements) {
    if (movement.type === "received") calculated += movement.amount;
    if (movement.type === "used") calculated -= movement.amount;
    if (movement.type === "inventoried") inventoried = movement.amount;
  }

  return {
    calculated,
    inventoried,
    difference: inventoried === null ? null : inventoried - calculated,
  };
}

export function formatNumber(value: number | null) {
  if (value === null) return "—";
  return new Intl.NumberFormat("fi-FI", { maximumFractionDigits: 2 }).format(value);
}
